class mVideo extends HTMLDivElement {
    constructor() {
        super();
        this.player = this.querySelector('video'); // created by freecaster (may take some time)
        this.playerContainer = this.querySelector('.freecaster-player');
        this.muteElem = this.querySelector('[data-video-control-mute]');
        this.playElem = this.querySelector('[data-video-control-play]');

        // bind this
        this.playerMuteHandler = this.playerMuteHandler.bind(this);
        this.playerPlayPauseHandler = this.playerPlayPauseHandler.bind(this);
        this.initPlayer = this.initPlayer.bind(this);
        this.onVideoPlay = this.onVideoPlay.bind(this);
    }

    connectedCallback() {
        if (!this.player) {
            this.waitTillPlayerLoaded();
        } else {
            this.initPlayer();
        }
    }

    /*
        This check if the custom elements managed by freecaster have loaded the video every 250ms until it's done
    */
    waitTillPlayerLoaded() {
        var loadingInterval = setInterval(() => {
            this.player = this.querySelector('video');
            if (this.player) {
                clearInterval(loadingInterval);
                this.initPlayer();
            }
        }, 250);
    }

    playerMuteHandler(event) {
        event.preventDefault();
        event.stopPropagation();

        this.player.muted = !this.player.muted;
        if (this.player.muted) {
            this.muteElem.classList.add('player-muted');
        } else {
            this.muteElem.classList.remove('player-muted');
        }
    }

    initPlayer() {
        // event handlers
        if (this.muteElem) {
            this.muteElem.addEventListener('click', this.playerMuteHandler);
        }
        if (this.playElem) {
            this.playElem.addEventListener('click', this.playerPlayPauseHandler);
        }
    }

    playerPlayPauseHandler(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.player.paused) {
            this.playElem.classList.add('player-played');
        } else {
            this.playElem.classList.remove('player-played');
        }
        this.player.togglePlay();
    }

    onVideoPlay() {
        this.classList.add('video-playing');
    }
}

customElements.define('m-video', mVideo, {
    extends: 'div'
});
